import { formatPoints, useAnimatedPoints } from './points-format'

/** A points balance that counts to its new value. See `points-format` for why. */
export function AnimatedPoints({ value, className }: { value: number; className?: string }) {
  const shown = useAnimatedPoints(value)
  return (
    <span className={className} aria-label={formatPoints(value)}>
      {formatPoints(shown)}
    </span>
  )
}
